/* eslint-disable react/no-unescaped-entities */
import React from 'react'

import { useCommonTx } from '~/hooks/useTranslationForNamespace'

export const Research = () => {
  const t = useCommonTx('landing.research')
  return (
    <div className='min-h-screen flex flex-col md:flex-row items-center justify-center gap-8 w-full px-10'>
      <div
        className='basis-[50%] w-full min-h-[70vw] h-full  bg-contain bg-no-repeat bg-center'
        style={{
          backgroundImage: "url('/assets/images/landing/mag-lens-bg.svg')",
        }}
      />
      <div className='basis-[50%] flex flex-col items-start justify-center gap-8'>
        <div className='text-title-1 font-bold font-serif mb-5'>{t('header')}</div>
        <div className='flex flex-col gap-7'>
          <div>
            <h3 className='text-heading-3 mb-2'>{t('subheader1')}</h3>
            <div className='text-body-text-1'>{t('body1')}</div>
          </div>
          <div>
            <h3 className='text-heading-3 mb-2'>{t('subheader2')}</h3>
            <div className='text-body-text-1'>{t('body2')}</div>
          </div>
          <div>
            <h3 className='text-heading-3 mb-2'>{t('subheader3')}</h3>
            <div className='text-body-text-1'>{t('body3')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
